// extracted by mini-css-extract-plugin
export default {"LogoPeacock":"PageProductHeroLogoPeacock_LogoPeacock__BeNo6"};